import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectDocumentCount = createSelector(
  [(store: RootState) => store.documentsSignerList.count],
  (count) => count
);
